import React from "react";
import styled from "styled-components";

function Header() {
  return (
    <HeaderNav>
      <Logo>
        <a href="http://">AS</a>
      </Logo>
      <Nav>
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/">About</a>
          </li>
          <li>
            <a href="/">More</a>
          </li>
        </ul>
      </Nav>
    </HeaderNav>
  );
}

export default Header;

const HeaderNav = styled.div`
  width: 100%;
  height: 9vh;
  display: flex;
  justify-content: space-around;
  background-color: black;
`;

const Logo = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    color: black;
    padding: 6px 10px;
    background-color: white;
    border-radius: 5px;
  }
`;

const Nav = styled.div`
  width: 50%;
  height100%;
  ul{
      width:100%;
      height:100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      list-style:none;
    }
`;
